import React, { useState } from 'react';

import { Button, Modal, Row, Form, Col, Radio, notification } from 'antd';
import { useIntl } from 'react-intl';
import * as api from 'services/api';
import apiPaths from 'services/apiPaths';
import NewAddressForm from 'src/components/shoppingCart/NewAddressForm';
import { CustomCloseIcon } from 'src/components/shoppingCart/ShoppingCart';
import { ICustomer, ICustomerAddress, IRegion } from 'src/shared/models';

const PREFIX = 'Mr';

const AddressModal = ({
  showCheckoutModal,
  setShowCheckoutModal,
  customer,
  stateList,
  updateMagentoData,
  userCountry,
}) => {
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(false);
  const [createNew, setCreateNew] = useState(false);
  const [formValues, setFormValues] = useState({
    addressName: '',
    addressNumber: '',
    zipcode: '',
    city: '',
    state: '',
    phoneNumber: '',
  });
  const [form] = Form.useForm();

  const formFields = [
    { name: 'addressName', completeName: 'Address Name' },
    { name: 'addressNumber', completeName: 'Address Number' },
    { name: 'zipcode', completeName: 'Zipcode', isNumber: true },
    { name: 'city', completeName: 'City' },
  ];

  const handleCreateAddress = async (formValues) => {
    const { city, zipcode: postcode } = formValues;
    const { firstname, lastname, middlename, telephone } = customer;
    const region: IRegion = stateList.available_regions.find(
      (region) => region.code === userCountry
    );

    const newAddress: ICustomerAddress = {
      customer_id: customer.id,
      country_id: userCountry,
      region: {
        region_code: userCountry.code,
        region: userCountry.name,
        region_id: userCountry.id,
      },
      street: [formValues['addressName'], formValues['addressNumber']],
      telephone,
      postcode,
      city,
      firstname,
      lastname,
      middlename,
      prefix: PREFIX,
      default_shipping: false,
      default_billing: false,
    };

    const data: { customer: ICustomer; address: ICustomerAddress } = {
      customer,
      address: newAddress,
    };

    try {
      setLoading(true);

      const response = await api.postDataCall({
        dataPath: apiPaths.MAGENTO.ISDIN_ADDRESS,
        data,
        callConfig: {},
      });

      notification.success({
        message: formatMessage({ id: 'form.address.create-success' }),
      });
      updateMagentoData(response.data);
      setShowCheckoutModal(false);
      // closeAddress();

      setLoading(false);
    } catch (err) {
      console.group(err);
      notification.error({
        message: formatMessage({ id: 'form.address.no-create' }),
      });
      setLoading(false);
    }
  };

  const handleEditInput = (key: string, value: string) => {
    setFormValues({ ...formValues, [key]: value ?? '' });
  };

  const getLabelName = (key: string) => {
    let className = `floating-${key}`;

    if (formValues[key] !== '') className += ` floating-${key}--filled`;

    return className;
  };

  return (
    <Modal
      visible={showCheckoutModal}
      footer={null}
      onCancel={() => setShowCheckoutModal(false)}
      className="shopping-cart-modal buy-modal"
      closeIcon={<CustomCloseIcon />}
      centered
      wrapClassName="buy-modal-wrapper"
    >
      <div className="challengeDetail__description--extended">
        <Row justify="start" align="middle" className="buy-modal__title-select">
          {formatMessage({ id: 'shopping-cart.buy-modal.title' })}
        </Row>
        <Form
          form={form}
          name="buy-materials"
          layout="vertical"
          className="buy-materials-form"
          onFinish={handleCreateAddress}
        >
          <Row className="buy-materials-form__address-Container">
            <Col span={24}>
              <div className="buy-materials-form__address-options">
                <Radio.Group className="address-radio-group">
                  {customer?.addresses?.map((address) => (
                    <Radio
                      key={address.id}
                      value={address.id}
                      onClick={() => setCreateNew(false)}
                    >
                      {address.street && (
                        <p className="address-radio-name">
                          {address.street?.join(' ')}
                        </p>
                      )}
                      {address.city && (
                        <p className="address-radio-name">{address.city}</p>
                      )}
                      {address.postcode && (
                        <p className="address-radio-name">{address.postcode}</p>
                      )}
                      {address.region && (
                        <p className="address-radio-name">
                          {address.region.region}
                        </p>
                      )}
                    </Radio>
                  ))}
                  <Radio value="New address" onClick={() => setCreateNew(true)}>
                    <span className="address-radio-name">
                      {formatMessage({
                        id: 'shopping-cart.buy-modal.add-option',
                      })}
                    </span>
                  </Radio>
                </Radio.Group>
              </div>
              {createNew && (
                <NewAddressForm
                  handleEditInput={handleEditInput}
                  getLabelName={getLabelName}
                  stateList={stateList}
                  formFields={formFields}
                />
              )}
              <Button
                htmlType="submit"
                className="btn-primary btn-primary--black"
                block
                disabled={loading}
              >
                {/* {formatMessage({ id: 'shopping-cart.buy-modal.title' })} */}
                {createNew ? 'Añadir y Solicitar' : 'Solicitar materiales'}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default AddressModal;
